<template>
	<div>
		<div class="products" ref="products" v-if="getProducts.length > 0">
			<card-product-big 
				v-for="product in getProducts" 
				:key="product.id"
				:product="product"
			/>
		</div>
		<div v-else class="d-flex align-center flex-column sorry-container">
			<h1 class="not-found">Sin resultados</h1>
			<h3 class="sorry">Lo sentimos, no hay productos que coincidan con tu búsqueda</h3>
			<button
				type="button"
				class="go-init"
				:style="`background-color:${globalColors.primary}`"
				@click="goTo"
			>Regresar a inicio</button>
		</div>
	</div>
</template>
<script>
import cardProductBig from '@/components/cardProductBig';
import { mapGetters } from 'vuex';

function goTo() {
	this.$router.push({ name: 'home' });
}

export default {
	name: 'Products',
	components: {
		cardProductBig,
	},
	computed: {
		...mapGetters([
			'getProducts',
		]),
	},
	methods: {
		goTo,
	},
};
</script>
<style lang="scss" scoped>
	.products {
		box-sizing: border-box;
		display: grid;
		grid-gap: 1rem;
		grid-template-columns: repeat(auto-fill, minmax(18rem, 1fr));
		margin: auto;
		max-width: 109rem;
		padding: 0 0 5.7rem;

		@media screen and (max-width: 645px) {
			display: block;
		}
}

	@media screen and (max-width: 1024px) {
		.products {
			padding: 0;
		}
	}

	.not-found {
		color: color(lineGrey);
		font-family: font(avenirBold);
		font-size: size(mslarge);
		margin-bottom: 0;
		text-transform: uppercase;
	}

	.sorry {
		color: color(text-grey-medium);
		font-family: font(avenirDemi);
		font-size: size(medium);
		text-transform: capitalize;
	}

	.go-init {
		color: white;
		border: none;
		border-radius: 8px;
		font-family: font(open-bold);
		height: 45px;
		width: 189px;
	}

	.sorry-container {
		margin-bottom: 23rem;
	}

</style>





// WEBPACK FOOTER //
// Products.vue?5fb23e8e